import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { ToolContext } from "../fluent/hoc/fluentToolWrapper";
import { DraggableLine } from "../fluent/primitives/draggable";
export const DraggableLineWithButtonComponent = (props) => {
    const { useFluent } = useContext(ToolContext);
    if (useFluent) {
        // When updating the callsites to use fluent directly this label will be clearer since the string replace occurs where the data string lives
        return _jsx(DraggableLine, { ...props, label: props.data.substring(0, props.data.length - (props.lenSuffixToRemove ?? 6)), onDelete: () => props.onIconClick(props.data) });
    }
    return (_jsxs("div", { className: "draggableLine withButton", title: props.tooltip, draggable: true, onDragStart: (event) => {
            event.dataTransfer.setData(props.format, props.data);
        }, children: [props.data.substring(0, props.data.length - (props.lenSuffixToRemove ?? 6)), _jsx("div", { className: "icon", onClick: () => {
                    props.onIconClick(props.data);
                }, title: props.iconTitle, children: _jsx("img", { className: "img", title: props.iconTitle, src: props.iconImage }) })] }));
};
//# sourceMappingURL=draggableLineWithButtonComponent.js.map